export default __webpack_public_path__ + "static/media/intebot_logo_bot.669f982a.svg";